import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './store/store';
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { getRecaptchaSiteKey } from './utils/getKeys';

const root = ReactDOM.createRoot(document.getElementById('root'));

const siteKey = getRecaptchaSiteKey();

root.render(
  <Provider store={store}>
    <BrowserRouter>
    <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
        <App />
    </GoogleReCaptchaProvider>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
